<template>
  <div v-if="item">
    <h3>Role</h3>
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/role-management">Role management</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li v-if="item" aria-current="page" class="active">
        Role - {{ item.id}}
      </li>
    </vs-breadcrumb>
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- GENERAL -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'General' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <role-general v-if="item" :role="item" @updateRole="updateRole" />
        </div>
      </vs-tab>

      <!-- PERMISSIONS -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Permissions' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <role-permissions  v-if="item" :role="item" @updateRole="updateRole"/>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import RoleGeneral from "./RoleGeneral.vue";
import RolePermissions from "./RolePermissions.vue";
export default {
  components: {
    RoleGeneral,
    RolePermissions
  },
  data() {
    return {
      roleId: "",
      item: null,
    };
  },
  methods: {
    getItem: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/Idam/Roles/" + this.roleId;

      this.$http
        .get(url)
        .then((resp) => {
          console.log("Role:", resp.data);
          this.item = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async updateRole(role) {
      this.item = role;
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  created() {
    this.roleId = this.$route.params.roleId;
    this.getItem();
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
